export default __webpack_public_path__ + "static/media/img-0579-iceland-half-face.ae31f783.png";